import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import giftClient, { KlydoGiftProps } from '../../../api/gift';

const useUpsertGiftMutation = (
  options?: UseMutationOptions<void, Error, KlydoGiftProps>,
) => {
  return useMutation({
    mutationKey: ['add-gift'],
    mutationFn: (input: KlydoGiftProps) => giftClient.upsertGift(input),
    ...options,
  });
};

export default useUpsertGiftMutation;
